import { render, staticRenderFns } from "./DeleteResourceAttachmentConfirmation.vue?vue&type=template&id=d4f138c2"
import script from "./DeleteResourceAttachmentConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteResourceAttachmentConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports